export const GET_USERS_DATA = "get_users";
export const CREATE_USER = "create_user";
export const EDIT_USER = "edit_user";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const DELETE_USER = "delete_user";
export const USER_ERROR = "user_error";
export const ACCESS_RIGHT_ERROR = "access_error";
export const GET_ACCESS_RIGHTS = "get_access_rights";
export const GET_CONSULTANT_COST = "get_consultant_costs";
export const NEW_CONSULTANT_COST = "new_consultant_costs";
